import { render, staticRenderFns } from "./BenefactorTab.vue?vue&type=template&id=c9f2ace2"
import script from "./BenefactorTab.vue?vue&type=script&lang=js"
export * from "./BenefactorTab.vue?vue&type=script&lang=js"
import style0 from "./BenefactorTab.vue?vue&type=style&index=0&id=c9f2ace2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports